import React from "react";

import MovieIcon from "public/icons/movie-filter.svg";

import { WithClassName } from "@/models/utils.models";
import { clsxm } from "@/utils/tailwindMerge";

import { SvgIcon } from "../svg-icon/SvgIcon";

type PropTypes = WithClassName;

export const IntroBadge: React.FC<PropTypes> = ({ className }) => {
  return (
    <div
      data-testid="introLabel"
      className={clsxm(
        "flex gap-1 absolute top-2 left-2 bg-green-600 px-2 py-[2px] rounded-full",
        className,
      )}
    >
      <SvgIcon width={16} height={16}>
        <MovieIcon />
      </SvgIcon>
      <span className="font-bold text-white text-[11px]">INTRO</span>
    </div>
  );
};
